import { render, staticRenderFns } from "./MobileNotifications.vue?vue&type=template&id=7e463b88&scoped=true"
import script from "./MobileNotifications.js?vue&type=script&lang=js&external"
export * from "./MobileNotifications.js?vue&type=script&lang=js&external"
import style0 from "./MobileNotifications.scss?vue&type=style&index=0&id=7e463b88&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e463b88",
  null
  
)

export default component.exports